module.exports = __webpack_public_path__ + "assets/checkbox-default.0a6fc804.svg";